// Generic, cross-cutting strings reused across many components.
// Component-specific text belongs in that component's own namespace file instead.
const common = {
  actions: {
    save: "Vista",
    cancel: "Hætta við",
    delete: "Eyða",
    edit: "Breyta",
    close: "Loka",
    submit: "Senda inn",
    confirm: "Staðfesta",
    back: "Til baka",
    next: "Næsta",
    previous: "Fyrra",
    search: "Leita",
    filter: "Sía",
    retry: "Reyna aftur",
    download: "Sækja",
    upload: "Hlaða upp",
    view: "Skoða",
    select: "Velja",
    ok: "Í lagi",
    yes: "Já",
    no: "Nei",
    logout: "Útskrá",
    settings: "Stillingar",
    create: "Búa til",
    update: "Uppfæra",
    remove: "Fjarlægja",
    add: "Bæta við",
    continue: "Áfram",
    done: "Lokið",
    refresh: "Endurhlaða",
    copy: "Afrita",
    copied: "Afritað",
  },
  languageSwitcher: {
    label: "Tungumál",
  },
  status: {
    loading: "Hleð...",
    saving: "Vistar...",
    submitting: "Sendi inn...",
    deleting: "Eyðir...",
    error: "Villa",
    success: "Tókst",
    pending: "Í vinnslu",
    approved: "Samþykkt",
    rejected: "Hafnað",
    completed: "Lokið",
    failed: "Mistókst",
  },
  fields: {
    name: "Nafn",
    email: "Netfang",
    date: "Dagsetning",
    created: "Búið til",
    updated: "Uppfært",
    status: "Staða",
    description: "Lýsing",
    type: "Tegund",
    role: "Hlutverk",
    project: "Verkefni",
    required: "Nauðsynlegt",
    optional: "Valkvætt",
  },
  misc: {
    all: "Allt",
    none: "Ekkert",
    unknown: "Óþekkt",
    somethingWentWrong: "Eitthvað fór úrskeiðis",
    noResultsFound: "Engar niðurstöður fundust",
  },
  requestStatus: {
    pending: "Í vinnslu",
    awaiting_confirmation: "Bíður staðfestingar",
    approved: "Samþykkt — bíður afhendingar",
    fulfilled: "Afgreitt",
    rejected: "Hafnað",
    redirected: "Framsent",
  },
};

export default common;
